@import "src/style/lib";

.stories-page {
  .tags {
    .filter-label {
      position: relative;
      width: 100%;
      max-width: 25rem;
      height: 1rem;
      margin: 0 auto;
      &::before {
        content: "";
        display: block;
        width: 100%;
        height: 9px;
        border-bottom: 1px solid $bjelin-light-grey;
      }
      > span {
        position: absolute;
        inset: 0;
        display: flex;
        justify-content: center;
        > span {
          display: block;
          text-transform: uppercase;
          font-size: 0.8em;
          padding: 0 0.5rem;
          background-color: #fafafa;
        }
      }
    }
    .filter-values {
      display: flex;
      justify-content: center;
      gap: 0.5em;
      margin: 0.7em 0.7em 1.4em;
      flex-wrap: wrap;
    }
  }
  .filter-heading {
    h5 {
      width: 100%;
      text-align: center;
    }
  }
}
